module.exports = __webpack_public_path__ + "media/images/team_member/member_4-a638b9c3c62df4610b828695ee491c29.jpg";